var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-data-table', {
    attrs: {
      "id": "table-fw",
      "headers": _vm.headers,
      "items": _vm.fws,
      "loading": _vm.loading,
      "min-height": "500px"
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function () {
        return [_c('v-toolbar', {
          attrs: {
            "flat": "",
            "color": "#598639",
            "dark": ""
          }
        }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t("Firmware")))]), _c('v-divider', {
          staticClass: "mx-4",
          attrs: {
            "inset": "",
            "vertical": ""
          }
        }), _c('v-spacer'), _c('v-dialog', {
          attrs: {
            "max-width": "750px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var on = _ref.on,
                  attrs = _ref.attrs;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "mb-2",
                attrs: {
                  "color": "black",
                  "dark": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(_vm.$t("Add Firmware")) + " ")])];
            }
          }]),
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v;
            },
            expression: "dialog"
          }
        }, [_c('v-card', {
          staticStyle: {
            "border-style": "solid",
            "border-color": "white"
          }
        }, [_c('v-toolbar', {
          attrs: {
            "color": "black",
            "dark": ""
          }
        }, [_c('v-toolbar-title', [_c('v-icon', {
          staticClass: "mr-3 mb-2",
          attrs: {
            "large": "",
            "color": "white"
          }
        }, [_vm._v("mdi-paperclip")]), _vm._v(" "), _c('span', {
          staticClass: "text-h5 white--text"
        }, [_vm._v(_vm._s(_vm.$t("Add Firmware")))])], 1)], 1), _c('v-card-text', [_c('v-container', {
          staticClass: "mt-3"
        }, [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('v-file-input', {
          attrs: {
            "accept": ".sfi",
            "placeholder": _vm.$t('Select your files'),
            "prepend-icon": "mdi-paperclip",
            "outlined": "",
            "label": "FWFile input",
            "loading": _vm.loading2
          },
          on: {
            "click:clear": _vm.clear
          },
          model: {
            value: _vm.files,
            callback: function ($$v) {
              _vm.files = $$v;
            },
            expression: "files"
          }
        })], 1)], 1)], 1), _c('v-card-actions', [_c('v-btn', {
          attrs: {
            "color": "warning"
          },
          on: {
            "click": _vm.close
          }
        }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _c('v-spacer'), _c('v-btn', {
          staticClass: "white--text",
          attrs: {
            "color": "#196619",
            "disabled": _vm.isSet
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('Upload')) + " ")])], 1)], 1)], 1)], 1)];
      },
      proxy: true
    }, {
      key: "item.UpdatedAt",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(new Date(item.UpdatedAt).toLocaleString()) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('v-icon', {
          attrs: {
            "color": "red"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteItem(item);
            }
          }
        }, [_vm._v(" mdi-delete ")])];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": _vm.initialize
          }
        }, [_vm._v(" Reset ")])];
      },
      proxy: true
    }])
  }), _c('v-col', {
    attrs: {
      "align-content": "center"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Select nozzles to update fw')))]), _c('v-row', [_c('v-col', [_c('v-select', {
    attrs: {
      "outlined": "",
      "flat": "",
      "small-chips": "",
      "single-line": "",
      "items": _vm.nozzles,
      "item-text": "bt_mac",
      "item-value": "id",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: _vm.nozzItems,
      callback: function ($$v) {
        _vm.nozzItems = $$v;
      },
      expression: "nozzItems"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', [_c('v-select', {
    attrs: {
      "outlined": "",
      "flat": "",
      "small-chips": "",
      "single-line": "",
      "items": _vm.fws,
      "item-text": "file_name",
      "item-value": "ID",
      "clearable": "",
      "hint": _vm.$t('Choose firmware'),
      "persistent-hint": ""
    },
    model: {
      value: _vm.fwUpdateID,
      callback: function ($$v) {
        _vm.fwUpdateID = $$v;
      },
      expression: "fwUpdateID"
    }
  })], 1), _c('v-col', [_c('v-btn', {
    staticClass: "white--text mt-3",
    attrs: {
      "dense": "",
      "color": "#196619",
      "disabled": _vm.nozzItems.length == 0
    },
    on: {
      "click": _vm.setUp
    }
  }, [_vm._v(_vm._s(_vm.$t('Proceed')))]), _c('v-btn', {
    staticClass: "white--text mt-3",
    attrs: {
      "dense": "",
      "color": "orange",
      "disabled": _vm.nozzItems.length == 0
    },
    on: {
      "click": _vm.unset
    }
  }, [_vm._v(_vm._s(_vm.$t('Remove')))])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: _vm.dialogDelete,
      callback: function ($$v) {
        _vm.dialogDelete = $$v;
      },
      expression: "dialogDelete"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.$t('Are you sure you want to delete this item?')))]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": _vm.closeDelete
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": "",
      "loading": _vm.loading2
    },
    on: {
      "click": _vm.deleteItemConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('OK')))]), _c('v-spacer')], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }